<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" content="底图设置"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">

            <el-form-item label="首页底图背景" prop="backGroundMain">
                <el-upload
                        class="single-image"
                        list-type="single-image"
                        :on-success="(value) => uploadSuccess('back_ground_main', value)"
                        :show-file-list="false"
                        :action="app_url + '/store/uploader/upload'">
                    <i class="icon el-icon-plus" v-if="!item.back_ground_main"></i>
                    <img :src="item.back_ground_main" v-else>
                </el-upload>
            </el-form-item>

            <el-form-item label="热门底图">
                <el-upload
                        class="single-image"
                        list-type="single-image"
                        :on-success="(value) => uploadSuccess('back_ground_hot', value)"
                        :show-file-list="false"
                        :action="app_url + '/store/uploader/upload'">
                    <i class="icon el-icon-plus" v-if="!item.back_ground_hot"></i>
                    <img :src="item.back_ground_hot" v-else>
                </el-upload>
            </el-form-item>


            <el-form-item label="会员中心底图">
                <el-upload
                        class="single-image"
                        list-type="single-image"
                        :on-success="(value) => uploadSuccess('back_ground_member', value)"
                        :show-file-list="false"
                        :action="app_url + '/store/uploader/upload'">
                    <i class="icon el-icon-plus" v-if="!item.back_ground_member"></i>
                    <img :src="item.back_ground_member" v-else>
                </el-upload>
            </el-form-item>

            <el-form-item label="购物车底图">
                <el-upload
                        class="single-image"
                        list-type="single-image"
                        :on-success="(value) => uploadSuccess('back_ground_cart', value)"
                        :show-file-list="false"
                        :action="app_url + '/store/uploader/upload'">
                    <i class="icon el-icon-plus" v-if="!item.back_ground_cart"></i>
                    <img :src="item.back_ground_cart" v-else>
                </el-upload>
            </el-form-item>

            <el-form-item>
                <el-button size="big" type="primary" @click="checkSubmit" v-auth="['store/setting/bgsetEdit']">保存</el-button>
            </el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {
                    back_ground_main: '',
                    back_ground_hot: '',
                    back_ground_member: '',
                    back_ground_cart: ''
                },
                isLoad: false,
                dialogVisible: false,
                // 图片列表
                backGroundMain: [],
                backGroundHot: [],
				backGroundMember: [],
				backGroundCart:[],
                rules: {

                }
            }
        },
        created() {
            this.loadData()
        },
        methods: {
			// 点击选择链接的这个按钮的时候 打开面板且定义一个全局的index 获取到点击了第几个index
			changeDialogVisibleNav() {
			    this.dialogVisibleNav = true;
			},
			selectNavValue(wz) {
			    this.item.hotPage = wz
			    this.dialogVisibleNav = false
			},
			// 选择链接的×关闭面板
			handleNavClose(done) {
			    this.dialogVisibleNav = false
			},
            loadData() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
				// 获取底图信息
                this.axios.post('/store/setting/bgset', {})
				.then(res => {
                    this.isLoad = !this.isLoad
                    if (res.data.detail) {
                        this.item = res.data.detail
                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            checkSubmit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false
                let url = '/store/setting/bgsetEdit'
                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            uploadSuccess(key, res, file) {
                this.item[key] = res.data.fileInfo.external_url
                this.$forceUpdate()
            },
        }
    }
</script>
<style scoped>
    .carousel-box {
        margin-top: 16px;
    }

    .carousel-box .carousel-box-input {
        width: 70%;
        margin-left: 12px;
    }

    .el-tabs--left, .el-tabs--righ {
        height: 300px !important;
    }

    /*面板名称*/
    .carousel-box-contain /deep/ .el-tabs__item.is-active {
        color: #67C23A !important
    }

    .carousel-box-contain /deep/ .el-tabs__item:hover {
        color: #67C23A !important
    }

    .carousel-box .carousel-button-danger {
        margin-left: 15px;
    }
    .navItem-input{
        margin-top: 16px;
    }
</style>
